import { displayDate, displayDateTime } from '../common/datePresentation';

const FIELD_LABELS = {
  classTypeId: 'Typ zajęć',
  teacherId: 'Nauczyciel',
  dayOfWeek: 'Dzień tygodnia',
  fromDate: 'Data rozpoczęcia',
  tillDate: 'Data zakończenia',
  startTime: 'Godzina rozpoczęcia',
  'lessonDetails.date': 'Data lekcji',
  'lessonDetails.startTime': 'Godzina lekcji',
  'lessonDetails.teacherId': 'Nauczyciel',
  'lessonDetails.classTypeId': 'Typ zajęć',
  'lessonDetails.attendanceStatus': 'Stan obecności',
  'lessonDetails.lessonStatus': 'Stan lekcji',
  'lessonDetails.attendanceCheckedAt': 'Czas sprawdzenia obecności',
  email: 'Adres e-mail',
  mobile: 'Telefon',
  additionalInfo: 'Informacje dodatkowe',
  schoolClassId: 'Grupa',
  studentId: 'Uczeń',
  archived: 'Archiwizacja',
  deleted: 'Usunięcie',
};
const STATUS_LABELS = {
  checked: 'Sprawdzona',
  notChecked: 'Niesprawdzona',
  partiallyCancelled: 'Częściowo odwołana',
  cancelled: 'Odwołana',
  scheduled: 'Zaplanowana',
  cancelledOnTime: 'Odwołana w terminie',
  cancelledLate: 'Odwołana po terminie',
  present: 'Obecny',
  absent: 'Nieobecny',
};

export function changeFieldLabel(field, studentLabels = {}, t) {
  const payrollFields = ['status', 'revision', 'amountCents', 'reason', 'rates'];
  const cancellationField = field.replace('lessonDetails.lessonCancellation.', '');
  if (t && (payrollFields.includes(field) || cancellationField !== field)) return t(`audit.fields.${cancellationField}`);
  if (FIELD_LABELS[field]) return FIELD_LABELS[field];
  const studentField = /^students\.([^.]+)\.(isPresent|participationStatus)$/.exec(field);
  if (studentField) return `${studentField[2] === 'isPresent' ? 'Obecność' : 'Udział'} ucznia ${studentLabels[studentField[1]] || studentField[1].slice(0, 8)}`;
  return field;
}

export function changeValueLabel(field, value, teacherOptions = [], classTypeOptions = [], t) {
  if (value === null || value === undefined) return '—';
  if (field === 'email' && value === '[ukryte]') return 'Wartość ukryta';
  if (field === 'amountCents') return (Number(value) / 100).toFixed(2);
  if (field.endsWith('.recordedAt')) return displayDateTime(value);
  if (t && ['teacher_verification', 'pending_approval', 'approved'].includes(value)) return t(value);
  if (t && field.endsWith('.mode')) return t(`audit.modes.${value}`);
  if (t && field === 'rates' && Array.isArray(value)) { return value.map(rate => `${t(rate.type)}: ${Number(rate.amount).toFixed(2)} (${displayDate(rate.valid_from)} – ${rate.valid_to ? displayDate(rate.valid_to) : '…'})`).join('; '); }
  if (field.endsWith('teacherId')) return (teacherOptions.find(option => option[0] === value) || [null, value])[1];
  if (field.endsWith('classTypeId')) return (classTypeOptions.find(option => option[0] === value) || [null, value])[1];
  if (field === 'fromDate' || field === 'tillDate' || field === 'lessonDetails.date') return displayDate(value);
  if (field === 'lessonDetails.attendanceCheckedAt') return displayDateTime(value);
  if (field.endsWith('.isPresent')) return value ? 'Obecny' : 'Nieobecny';
  return STATUS_LABELS[value] || String(value);
}
